import { takeLatest, call, put } from "redux-saga/effects";

import API_ENDPOINTS from "@services/apiConfig";
import axios from 'axios';
import AuthManager from "@services/AuthManager";
import { getFileNameFromContentDispositionHeader } from "@utils/common";

export const actionTypes = {
    fetchPlanDetails: 'PARTNER/FETCH_PLAN_DETAILS_INITIATED',
    fetchPlanDetailsSuccess: 'PARTNER/FETCH_PLAN_DETAILS_SUCCESS',
    fetchPlanDetailsFailed: 'PARTNER/FETCH_PLAN_DETAILS_FAILED',

    downloadPlan: 'PARTNER/DOWNLOAD_PLAN_INITITATED',
    downloadPlanSuccess: 'PARTNER/DOWNLOAD_PLAN_SUCCESS',
    downloadPlanFailed: 'PARTNER/DOWNLOAD_PLAN_FAILED',

    downloadPlatformFee: 'PARTNER/DOWNLOAD_PLATFORM_FREE_INITITATED',
    downloadPlatformFeeSuccess: 'PARTNER/DOWNLOAD_PLATFORM_FREE_SUCCESS',
    downloadPlatformFeeFailed: 'PARTNER/DOWNLOAD_PLATFORM_FREE_FAILED',
};

export const actions = {
    fetchPlanDetails: (data) => ({ type: actionTypes.fetchPlanDetails, payload: data }),
    downloadPlan: (data) => ({
        type: actionTypes.downloadPlan,
        payload: data,
    }),
    downloadPlanFailed: (data) => ({
        type: actionTypes.downloadPlanFailed,
        payload: data,
    }),
    downloadPlanSuccess: (data) => ({
        type: actionTypes.downloadPlanSuccess,
        payload: data,
    }),
    downloadPlatformFee: (data) => ({
        type: actionTypes.downloadPlatformFee,
        payload: data,
    }),
    downloadPlatformFeeSuccess: (data) => ({
        type: actionTypes.downloadPlatformFeeSuccess,
        payload: data,
    }),
    downloadPlatformFeeFailed: (data) => ({
        type: actionTypes.downloadPlatformFeeFailed,
        payload: data,
    }),
};

const initialState = {
    fetching: false,
    fetched: false,
    data: {},
    errMsg: null,
    download:{
        fetching: false,
        fetched: false,
        data: {},
        errMsg: null,
    },
    downloadPlatformFee: {
      fetching: false,
      fetched: false,
      data: {},
      errMsg: null,
    }
};

export const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.fetchPlanDetails: {
            return {
                ...state,
                fetching: true,
            }
        }
        case actionTypes.fetchPlanDetailsSuccess: {
            return {
                ...state,
                fetched: true,
                fetching: false,
                data: action.payload,
            }
        }
         case actionTypes.fetchPlanDetailsFailed: {
            return {
                ...state,
                fetched: true,
                errMsg: action.payload,
            }
        }
        case actionTypes.downloadPlan: {
            return { 
              ...state,
               download :
                 {
                   ...state.download,
                  fetching: true
                } 
            };
          }
          case actionTypes.downloadPlanFailed: {
            return {
              ...state,
              download:
              {
                ...state.download,
                fetching: false,
                fetched: false,
                errMsg: action.payload,
              }
            };
          }
          case actionTypes.downloadPlanSuccess: {
            return {
              ...state,
              download:
              {
                ...state.download,
                fetching: false,
                fetched: true,
                data: action.payload,
                errMsg: null,
              }
            };
          }
          case actionTypes.downloadPlatformFee: {
              return { 
                ...state,
                 downloadPlatformFee :
                   {
                     ...state.downloadPlatformFee,
                    fetching: true
                  } 
              };
            }
            case actionTypes.downloadPlatformFeeFailed: {
              return {
                ...state,
                downloadPlatformFee:
                {
                  ...state.downloadPlatformFee,
                  fetching: false,
                  fetched: false,
                  errMsg: action.payload,
                }
              };
            }
            case actionTypes.downloadPlatformFeeSuccess: {
              return {
                ...state,
                downloadPlatformFee:
                {
                  ...state.downloadPlatformFee,
                  fetching: false,
                  fetched: true,
                  data: action.payload,
                  errMsg: null,
                }
              };
            }
        default:
            return state;
    }
};

export const selectors = {
    getPlan: (state) => state.partnerApp.plan.data,
    getFeeType: (state) => state.partnerApp.plan.data && state.partnerApp.plan.data.feeType, 
    isFetching: (state) => state.partnerApp.reseller.fetching,
    isFetched: (state) => state.partnerApp.reseller.fetched,
    getLogo: (state) => state.partnerApp.reseller.data.icon_url || '', 
    getName: (state) => state.partnerApp.reseller.data.name || '',
    getPlanDetails: (state) => state.partnerApp.reseller.data.plan && state.partnerApp.reseller.data.plan.plan_details || [] ,
    getSecondaryPlanDetails: (state) => state.partnerApp.reseller.data.secondary_plan && state.partnerApp.reseller.data.secondary_plan.plan_details || [],
    getResellerEmail: (state) => state.partnerApp.reseller.data.email || '',
    getResellerMobile: (state) => state.partnerApp.reseller.data.registered_mobile || '',
};


function* fetchPlanWorker(action) {
    const reseller_uuid = AuthManager.getResellerId();
    try {
      const response = yield call(
        [axios, 'get'],
        API_ENDPOINTS.PLAN_DETAILS({ reseller_uuid, business_category_id: action.payload.id })
      )
      yield put({ type: actionTypes.fetchPlanDetailsSuccess, payload: response.data });
    } catch (err) {
      const errResponse = yield err.response;
    }
  }

function* downloadPlanWorker() {
    const params = {
    reseller_uuid: AuthManager.getResellerId(),
   }
    try {
      const response = yield axios.get(API_ENDPOINTS.DOWNLOAD_PLAN_DETAILS, { 
        responseType: 'blob',
        params,
      });
      if (response.status == 200) {
        const fileName = getFileNameFromContentDispositionHeader(response.headers["content-disposition"]) || 'partner_rates.xls';
        const blob = new Blob([response.data], {type: 'application/vnd.ms-excel'});
        const url = URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName;
        document.body.appendChild(a);
        a.click();
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
        yield put(actions.downloadPlanSuccess(response.data.result));
      }
    } catch (err) {
      const errMsg = (err && err.message) || "Something went wrong";
      yield put(actions.downloadPlanFailed(errMsg));
    } 
  }

function* downloadPlatformFeeWorker(action) {
  const params = {
    reseller_uuid: AuthManager.getResellerId(),
    fee_type: action.payload
  }
  try {
    const response = yield axios.get(API_ENDPOINTS.DOWNLOAD_PLATFORM_FEE_DETAILS, {
      responseType: 'blob',
      params,
    });
    if (response.status == 200) {
      if(response?.headers?.["content-type"] != 'application/pdf') {
        yield put(actions.downloadPlatformFeeFailed('No rates have been set for you for platform fee'));
        return;
      }
      const fileName = getFileNameFromContentDispositionHeader(response.headers["content-disposition"]) || 'platform_fee.pdf';
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      URL.revokeObjectURL(url);
      document.body.removeChild(a);
      yield put(actions.downloadPlatformFeeSuccess(response.data.result));
    }
  } catch (err) {
    const errMsg = (err && err.message) || "Something went wrong";
    yield put(actions.downloadPlatformFeeFailed(errMsg));
  }
}

export function* saga() {
    yield takeLatest(actionTypes.fetchPlanDetails, fetchPlanWorker);
    yield takeLatest(actionTypes.downloadPlan, downloadPlanWorker);
    yield takeLatest(actionTypes.downloadPlatformFee, downloadPlatformFeeWorker);
}